import React from 'react';
import { Popup } from 'devextreme-react/popup';
// import DataGridBase from '../../../../../partials/layout/DataGridBase';
import { DataGrid } from 'devextreme-react';


class CopyTracksModal extends React.Component {

    state = {
        records: [],
    }
    componentDidUpdate(revProps, prevState) {
        //Modal closed
        if (revProps.visible === true && this.props.visible === false) {
            this.setState({ records: [] });
        }
        // Modal opened
        else if (revProps.visible !== this.props.visible && this.props.visible === true) {
            let newRecords = [];
            if (this.props.records) {
                newRecords = JSON.parse(JSON.stringify(this.props.records));
            }
            this.setState({ records: newRecords });
        }
    }
    onClose = () => {
        this.props.onDialogResult();
    }
    groupTemplate = (item) => {
        return <div>{`Copied: ${item.copiedByName} ${item.copiedDateTime}`}</div>;
    }

    render() {
        return (
            <Popup
                visible={this.props.visible}
                onHiding={this.onClose}
                dragEnabled={!this.props.disabled ? true : false}
                hideOnOutsideClick={true}
                showTitle={true}
                title={this.props.title}
                width={900}
                height={600}>
                <div style={{ width: "100%", height: "100%" }} id='copyTracksModalDIV'>
                    {
                        this.state.records.length > 0 ? (
                            <DataGrid
                                width={"100%"}
                                style={{ width: '100%', height: '100%' }}
                                dataSource={this.state.records}
                                columns={
                                    [
                                        { caption: "URL", dataField: "url", width:"auto" },
                                        { caption: "Copy Template ID", dataField: "copiedTemplateID", width: "auto" },
                                        { caption: "Copy Template Name", dataField: "copiedTemplateName", width: "auto" },
                                        { caption: "Contract ID", dataField: "contractID", width: "auto" },
                                        { caption: "Copied By Account ID", dataField: "copiedById", width: "auto" },
                                        { caption: "Copied By Name", dataField: "copiedByName", width: "auto" },
                                        { caption: "Date Time", dataField: "copiedDateTime", width: "auto" },
                                    ]
                                }
                                showBorders={true}
                                showColumnLines={true}
                                showRowLines={true}
                                columnAutoWidth={true}
                            />
                        ) :
                            (
                                <div>No copy history records found!</div>
                            )
                    }
                </div>
            </Popup>
        );
    }
}

export default CopyTracksModal;